// extracted by mini-css-extract-plugin
export default {"form":"CategoryDialog_form__i9k70","input":"CategoryDialog_input__VOT-j"};